import React from "react";
import clsx from 'clsx';
import { SvgIcon } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  root: {
    width: 22,
    height: 22
  }
});

class IcTwitter extends React.Component {

  render() {
    const { classes, className } = this.props;

    return <SvgIcon className = { clsx(classes.root, className) }
                    titleAccess = 'Twitter'
                    viewBox = { "0 0 22 22" } >
      <path d="M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z" fill="#004876"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M17.1111 7.34098C16.6621 7.54958 16.1785 7.69065 15.6713 7.75368C16.1893 7.42952 16.5867 6.91552 16.774 6.30322C16.289 6.60337 15.7531 6.82172 15.1806 6.93878C14.7244 6.42928 14.0723 6.11112 13.3506 6.11112C11.9667 6.11112 10.844 7.28545 10.844 8.73367C10.844 8.93927 10.8655 9.13887 10.9086 9.33097C8.82453 9.22141 6.97725 8.17839 5.73974 6.58986C5.52381 6.97855 5.40042 7.42952 5.40042 7.90976C5.40042 8.81921 5.84305 9.62211 6.51596 10.0926C6.10561 10.0798 5.71822 9.96053 5.37961 9.76543V9.7977C5.37961 11.0688 6.24407 12.1291 7.3919 12.3692C7.1817 12.4307 6.96003 12.4615 6.73118 12.4615C6.56977 12.4615 6.41194 12.4458 6.25914 12.415C6.57838 13.4565 7.50381 14.2151 8.60142 14.2354C7.74342 14.9392 6.66159 15.3587 5.48722 15.3587C5.28492 15.3587 5.08476 15.3467 4.88892 15.3227C5.99872 16.0655 7.31729 16.5 8.73271 16.5C13.3455 16.5 15.8672 12.5043 15.8672 9.03832C15.8672 8.92426 15.865 8.81021 15.8607 8.6984C16.3507 8.32847 16.7761 7.86699 17.1111 7.34098Z" fill="#1A1919"/>
    </SvgIcon>
  }
}

export default withStyles(styles)(IcTwitter);
